(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-authors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var COLORS = ['#8b5e34', '#3c6e57', '#7a3e48', '#2f5d7c', '#6b4f8a', '#a0522d', '#4a6b2f', '#9a6b1f', '#355c5c', '#5b4636'];
    var SUFFIX = /^(jr|sr|ii|iii|iv)\.?$/i;

    function hash(s) { var h = 0; for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return Math.abs(h); }
    function initials(n) {
      var w = n.replace(/\./g, ' ').split(/\s+/).filter(function (x) { return x && !SUFFIX.test(x); });
      if (!w.length) return '?';
      return (w[0][0] + (w.length > 1 ? w[w.length - 1][0] : '')).toUpperCase();
    }
    function surname(n) {
      var w = n.split(/\s+/).filter(function (x) { return x && !SUFFIX.test(x.replace(/,/g, '')); });
      return (w[w.length - 1] || n).replace(/[^A-Za-zÀ-ɏ'-]/g, '');
    }
    function letterOf(n) {
      var c = surname(n).charAt(0).toUpperCase();
      return /[A-Z]/.test(c) ? c : '#';
    }
    // Exact-name search; for names with initials also try "C.S. Lewis" and "Wesley Duewel" spellings
    function query(n) {
      var v = ['"' + n + '"'];
      if (/\b[A-Z]\./.test(n)) {
        v.push('"' + n.replace(/([A-Z])\.\s+(?=[A-Z]\.)/g, '$1.') + '"');
        var w = n.split(/\s+/);
        if (w.length > 2 && !/^[A-Z]\.$/.test(w[0])) {
          v.push('"' + w.filter(function (x, i) { return i === 0 || i === w.length - 1 || !/^[A-Z]\.$/.test(x); }).join(' ') + '"');
        }
      }
      return v.filter(function (x, i) { return v.indexOf(x) === i; }).join(' OR ');
    }
    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var grid = root.querySelector('[data-csa-grid]');
      var input = root.querySelector('[data-csa-search]');
      var letters = root.querySelector('[data-csa-letters]');
      var title = root.querySelector('[data-csa-group-title]');
      var total = root.querySelector('[data-csa-total]');
      var more = root.querySelector('[data-csa-more]');
      var empty = root.querySelector('[data-csa-empty]');
      var popularN = parseInt(root.dataset.popular, 10) || 24;
      var byFirst = root.dataset.sort === 'first';
      var noun = root.dataset.noun || 'authors';
      var popularTitle = root.dataset.popularTitle || 'Popular';
      function sortKey(n) { return byFirst ? n.toLowerCase().replace(/^the\s+/, '') : surname(n).toLowerCase() + ' ' + n.toLowerCase(); }
      function letterFor(n) { var c = (byFirst ? n.replace(/^the\s+/i, '') : surname(n)).charAt(0).toUpperCase(); return /[A-Z]/.test(c) ? c : '#'; }
      var searchBase = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'search?type=product&q=';
      var photos = {};
      try { photos = JSON.parse(root.querySelector('[data-csa-photos]').textContent || '{}'); } catch (e) {}

      var all = [], byLetter = {}, current = [], shown = 0, PAGE = 60, mode = 'popular';

      function card(a) {
        var li = el('li', 'csa__card');
        var link = el('a', 'csa__link');
        link.href = searchBase + encodeURIComponent(a.q || query(a.n));
        var av = el('span', 'csa__avatar');
        var src = photos[a.n.toLowerCase()];
        if (src) {
          var img = el('img', 'csa__img');
          img.loading = 'lazy'; img.decoding = 'async'; img.alt = a.n; img.width = 240; img.height = 240;
          img.src = src;
          av.appendChild(img);
        } else {
          av.style.setProperty('--csa-av', COLORS[hash(a.n) % COLORS.length]);
          av.setAttribute('aria-hidden', 'true');
          av.textContent = initials(a.n);
        }
        var name = el('span', 'csa__name', a.n);
        name.appendChild(el('span', 'csa__books', a.c + (a.c === 1 ? ' book' : ' books')));
        link.appendChild(av); link.appendChild(name); li.appendChild(link);
        return li;
      }

      function render(list, heading) {
        current = list; shown = 0; grid.innerHTML = '';
        title.textContent = heading || '';
        empty.hidden = list.length > 0;
        page();
      }
      function page() {
        var frag = document.createDocumentFragment();
        var end = Math.min(current.length, shown + PAGE);
        for (var i = shown; i < end; i++) frag.appendChild(card(current[i]));
        grid.appendChild(frag);
        shown = end;
        more.hidden = shown >= current.length;
      }

      function setPressed(btn) {
        letters.querySelectorAll('.csa__letter').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      }

      function showPopular(btn) {
        mode = 'popular';
        render(all.slice(0, popularN), popularTitle);
        setPressed(btn || letters.querySelector('[data-l="popular"]'));
      }
      function showLetter(l, btn) {
        mode = l;
        render(byLetter[l] || [], (l === '#' ? 'Other' : l) + ' — ' + (byLetter[l] || []).length + ' ' + noun);
        setPressed(btn);
      }

      function buildLetters() {
        var keys = ['popular', 'all'].concat('ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''), ['#']);
        keys.forEach(function (k) {
          var b = el('button', 'csa__letter', k === 'popular' ? 'Popular' : k === 'all' ? 'All' : k);
          b.type = 'button'; b.dataset.l = k; b.setAttribute('aria-pressed', 'false');
          if (k.length === 1 && !byLetter[k]) b.disabled = true;
          b.addEventListener('click', function () {
            input.value = '';
            if (k === 'popular') showPopular(b);
            else if (k === 'all') { mode = 'all'; render(all.slice().sort(function (x, y) { return x.s.localeCompare(y.s); }), 'All ' + noun + ' (A–Z)'); setPressed(b); }
            else showLetter(k, b);
          });
          letters.appendChild(b);
        });
      }

      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var q = input.value.trim().toLowerCase();
          if (q.length < 2) { if (mode === 'search') showPopular(); return; }
          mode = 'search';
          var words = q.split(/\s+/);
          var res = all.filter(function (a) { return words.every(function (w) { return a.k.indexOf(w) !== -1; }); });
          render(res, res.length + ' found');
          setPressed(null);
        }, 150);
      });
      more.addEventListener('click', page);

      fetch(root.dataset.src, { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (rows) {
          all = rows.map(function (r) {
            var a = { n: r[0], c: r[1], q: r[2] || '' };
            a.k = a.n.toLowerCase().replace(/\./g, '');
            a.s = sortKey(a.n);
            a.l = letterFor(a.n);
            return a;
          });
          all.forEach(function (a) { (byLetter[a.l] = byLetter[a.l] || []).push(a); });
          Object.keys(byLetter).forEach(function (l) { byLetter[l].sort(function (x, y) { return x.s.localeCompare(y.s); }); });
          total.textContent = all.length.toLocaleString() + ' ' + noun;
          buildLetters();
          var hash = (location.hash || '').replace('#', '').toUpperCase();
          if (hash.length === 1 && byLetter[hash]) showLetter(hash, letters.querySelector('[data-l="' + hash + '"]'));
          else showPopular();
        })
        .catch(function () { /* keep the server-rendered cards */ });
    }

    function boot() { document.querySelectorAll('[data-csa]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-banner-slideshow')) {
    customElements.define(
      'custom-banner-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.cbs__track');
          this.slides = Array.from(this.querySelectorAll('.cbs__slide'));
          this.dots = Array.from(this.querySelectorAll('.cbs__dot'));
          this.pauseBtn = this.querySelector('.cbs__pause');
          this.index = 0;
          this.holds = new Set();
          this.updateSlides();
          if (!this.track || this.slides.length < 2) return;

          this.delay = parseInt(this.dataset.speed, 10) || 5000;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion;
          if (!this.autoplay && this.pauseBtn) this.pauseBtn.hidden = true;

          const prev = this.querySelector('.cbs__arrow--prev');
          const next = this.querySelector('.cbs__arrow--next');
          if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
          if (next) next.addEventListener('click', () => this.go(this.index + 1));
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
          if (this.pauseBtn) {
            this.pauseBtn.addEventListener('click', () => this.setPaused(!this.classList.contains('is-paused')));
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
              });
            },
            { root: this.track, threshold: 0.6 }
          );
          this.slides.forEach((slide) => this.observer.observe(slide));

          const hold = (key) => () => {
            this.holds.add(key);
            this.stop();
          };
          const release = (key) => () => {
            this.holds.delete(key);
            this.start();
          };
          this.addEventListener('mouseenter', hold('hover'));
          this.addEventListener('mouseleave', release('hover'));
          this.addEventListener('focusin', (e) => {
            if (e.target.matches(':focus-visible')) hold('focus')();
          });
          this.addEventListener('focusout', (e) => {
            if (!this.contains(e.relatedTarget)) release('focus')();
          });
          this.track.addEventListener('touchstart', hold('touch'), { passive: true });
          this.track.addEventListener('touchend', release('touch'), { passive: true });

          this.onVisibility = () => (document.hidden ? this.stop() : this.start());
          document.addEventListener('visibilitychange', this.onVisibility);

          this.addEventListener('shopify:block:select', (e) => {
            this.holds.add('editor');
            this.stop();
            const i = this.slides.indexOf(e.target);
            if (i > -1) this.go(i, 'auto');
          });
          this.addEventListener('shopify:block:deselect', release('editor'));

          this.start();
        }

        disconnectedCallback() {
          this.stop();
          if (this.observer) this.observer.disconnect();
          if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        }

        go(i, behavior) {
          const n = this.slides.length;
          const target = this.slides[((i % n) + n) % n];
          this.track.scrollTo({ left: target.offsetLeft, behavior: behavior || 'smooth' });
          if (this.timer) this.start();
        }

        setActive(i) {
          if (i < 0 || i === this.index) return;
          this.index = i;
          this.dots.forEach((dot, k) => {
            if (k === i) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.updateSlides();
        }

        updateSlides() {
          this.slides.forEach((slide, k) => {
            const active = k === this.index;
            slide.setAttribute('aria-hidden', String(!active));
            slide.querySelectorAll('a, button').forEach((el) => {
              if (active) el.removeAttribute('tabindex');
              else el.setAttribute('tabindex', '-1');
            });
          });
        }

        start() {
          this.stop();
          if (!this.autoplay || this.classList.contains('is-paused') || this.holds.size || document.hidden) return;
          this.timer = setInterval(() => this.go(this.index + 1), this.delay);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
        }

        setPaused(paused) {
          this.classList.toggle('is-paused', paused);
          if (this.pauseBtn) this.pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
          if (paused) this.stop();
          else this.start();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-delete-account"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function digits(s) { return (s || '').replace(/\D/g, ''); }
    function samePhone(a, b) {
      a = digits(a); b = digits(b);
      if (a.length < 8 || b.length < 8) return false;
      return a.slice(-10) === b.slice(-10);
    }
    function init(form) {
      if (!form || form.dataset.cdaReady) return;
      form.dataset.cdaReady = '1';
      var box = form.querySelector('[data-cda-check]');
      if (!box) return;
      var input = box.querySelector('input');
      var msg = box.querySelector('[data-cda-msg]');
      var agree = form.querySelector('[data-cda-agree]');
      var submit = form.querySelector('[data-cda-submit]');
      var email = (box.dataset.email || '').trim().toLowerCase();
      var phone = box.dataset.phone || '';
      var hint = msg.textContent;

      function matches() {
        var v = input.value.trim();
        if (!v) return null;
        if (v.indexOf('@') !== -1) return email !== '' && v.toLowerCase() === email;
        return phone !== '' && samePhone(v, phone);
      }
      function update() {
        var m = matches();
        box.classList.toggle('is-ok', m === true);
        box.classList.toggle('is-bad', m === false);
        if (m === true) msg.textContent = 'Matches your account.';
        else if (m === false) msg.textContent = 'This does not match the email or phone of the account you are signed in with.';
        else msg.textContent = hint;
        submit.disabled = !(m === true && agree.checked);
      }
      input.addEventListener('input', update);
      agree.addEventListener('change', update);
      form.addEventListener('submit', function (e) {
        if (matches() !== true || !agree.checked) { e.preventDefault(); update(); input.focus(); }
      });
      update();
    }
    function boot() { document.querySelectorAll('form.cda__form').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-collection-pro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-collection-slider')) {
    customElements.define(
      'custom-collection-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.cfc__grid');
          this.prev = this.querySelector('.cfc__arrow--prev');
          this.next = this.querySelector('.cfc__arrow--next');
          if (this.track && this.prev && this.next) {
            this.prev.addEventListener('click', () => this.page(-1));
            this.next.addEventListener('click', () => this.page(1));
            this.onScroll = () => this.updateArrows();
            this.track.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onScroll);
            this.updateArrows();
          }
          this.querySelectorAll('.cfc__form').forEach((form) => form.addEventListener('submit', (e) => this.addToCart(e, form)));
        }

        disconnectedCallback() {
          if (this.onScroll) window.removeEventListener('resize', this.onScroll);
        }

        page(dir) {
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
        }

        updateArrows() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= max;
        }

        // Adds to cart without leaving the page and lets the theme update its cart icon and cart drawer.
        async addToCart(event, form) {
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          const formData = new FormData(form);
          const id = Number(formData.get('id'));
          const quantity = Number(formData.get('quantity')) || 1;
          const sections = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || root + 'cart/add';
          if (button) button.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id, quantity }], sections: sections.join(',') }),
            });
            const data = await response.json();
            if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
            form.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: {},
                  sourceId: String(id),
                  data: { source: 'product-form-component', itemCount: quantity, productId: button ? button.dataset.productId : undefined, sections: data.sections },
                },
              })
            );
            if (button) {
              button.textContent = button.dataset.added || 'Added';
              setTimeout(() => (button.textContent = button.dataset.label || 'Add to cart'), 2000);
            }
          } catch (error) {
            // Fall back to the normal cart page if the quick add does not work.
            HTMLFormElement.prototype.submit.call(form);
          } finally {
            if (button) button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-mega-menu"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-mega-menu')) {
    customElements.define(
      'custom-mega-menu',
      class extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.cmm__item--parent'));
          this.pointerType = 'mouse';

          this.items.forEach((item) => {
            const top = item.querySelector('.cmm__top');
            if (!top) return;

            top.addEventListener('pointerdown', (e) => {
              this.pointerType = e.pointerType;
            });
            // On touch screens the first tap opens the panel, the second tap follows the link.
            top.addEventListener('click', (e) => {
              if (this.pointerType !== 'mouse' && !item.classList.contains('is-open')) {
                e.preventDefault();
                this.open(item);
              }
            });
            item.addEventListener('mouseleave', () => item.classList.remove('is-dismissed'));
            item.addEventListener('focusout', (e) => {
              if (!item.contains(e.relatedTarget)) {
                item.classList.remove('is-dismissed');
                this.close(item);
              }
            });
            item.addEventListener('keydown', (e) => {
              if (e.key === 'Escape') {
                item.classList.add('is-dismissed');
                this.close(item);
                top.focus();
              }
            });
          });

          this.onDocClick = (e) => {
            if (!this.contains(e.target)) this.closeAll();
          };
          document.addEventListener('click', this.onDocClick);

          this.addEventListener('shopify:block:select', (e) => {
            const item = e.target.closest('.cmm__item');
            if (item) this.open(item);
          });
          this.addEventListener('shopify:block:deselect', () => this.closeAll());

          this.setupSticky();
          this.setupDrawer();
        }

        // Mobile side drawer. It is moved to <body> so no page element can cover it.
        setupDrawer() {
          this.toggle = this.querySelector('.cmm__mobile-toggle');
          this.drawer = this.querySelector('.cmm__drawer');
          this.backdrop = this.querySelector('.cmm__backdrop');
          if (!this.toggle || !this.drawer || !this.backdrop) return;
          document.body.appendChild(this.backdrop);
          document.body.appendChild(this.drawer);
          this.drawer.setAttribute('aria-hidden', 'true');
          this.drawer.inert = true;

          this.toggle.addEventListener('click', () => this.openDrawer());
          [this.drawer, this.backdrop].forEach((el) =>
            el.addEventListener('click', (e) => {
              if (e.target.closest('[data-cmm-close]')) this.closeDrawer();
            })
          );
          this.drawer.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.closeDrawer();
          });
          // Close after choosing a link, so the drawer is not open on the next page (back/forward cache).
          this.drawer.addEventListener('click', (e) => {
            if (e.target.closest('a[href]')) this.closeDrawer(false);
          });
          this.onResize = () => {
            if (window.innerWidth >= 990) this.closeDrawer(false);
          };
          window.addEventListener('resize', this.onResize);
        }

        openDrawer() {
          this.drawer.inert = false;
          this.drawer.removeAttribute('aria-hidden');
          this.drawer.classList.add('is-open');
          this.backdrop.classList.add('is-open');
          this.toggle.setAttribute('aria-expanded', 'true');
          document.documentElement.style.overflow = 'hidden';
          const close = this.drawer.querySelector('.cmm__drawer-close');
          if (close) setTimeout(() => close.focus({ preventScroll: true }), 50);
        }

        closeDrawer(returnFocus = true) {
          if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
          this.drawer.classList.remove('is-open');
          this.backdrop.classList.remove('is-open');
          this.drawer.setAttribute('aria-hidden', 'true');
          this.drawer.inert = true;
          this.toggle.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
          if (returnFocus) this.toggle.focus({ preventScroll: true });
        }

        // Measures the theme header so the menu can sit inside it or stick right below it.
        // Works with a normal header and with Savor's transparent (overlapping) header.
        setupSticky() {
          const host = this.closest('.shopify-section');
          if (!host) return;
          let prev = host.previousElementSibling;
          while (prev && !prev.classList.contains('shopify-section')) prev = prev.previousElementSibling;
          if (!prev) return;
          const inner = prev.querySelector('header-component, header, .header') || prev.firstElementChild;
          const apply = () => {
            const flow = prev.offsetHeight;
            const visible = Math.max(flow, inner ? inner.offsetHeight : 0);
            host.style.setProperty('--cmm-header-h', visible + 'px');
            host.style.setProperty('--cmm-extra', visible - flow + 'px');
          };
          apply();

          // Savor's transparent header shows white text with no background, which hides it
          // (and the menu) over the page. Keep it in its solid "scrolled" look instead.
          const headerEl = prev.querySelector('header-component[transparent]');
          if (headerEl && this.dataset.solidHeader === 'true') {
            const keepSolid = () => {
              if (headerEl.dataset.stickyState !== 'active') headerEl.dataset.stickyState = 'active';
            };
            keepSolid();
            this.headerObserver = new MutationObserver(keepSolid);
            this.headerObserver.observe(headerEl, { attributes: true, attributeFilter: ['data-sticky-state'] });
          }

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(apply);
            this.resizeObserver.observe(prev);
            if (inner) this.resizeObserver.observe(inner);
          }
        }

        disconnectedCallback() {
          if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.headerObserver) this.headerObserver.disconnect();
          if (this.onResize) window.removeEventListener('resize', this.onResize);
          if (this.drawer) {
            document.documentElement.style.overflow = '';
            this.drawer.remove();
            this.backdrop.remove();
          }
        }

        open(item) {
          this.items.forEach((other) => {
            if (other !== item) this.close(other);
          });
          item.classList.remove('is-dismissed');
          item.classList.add('is-open');
          const top = item.querySelector('.cmm__top');
          if (top) top.setAttribute('aria-expanded', 'true');
        }

        close(item) {
          item.classList.remove('is-open');
          const top = item.querySelector('.cmm__top');
          if (top) top.setAttribute('aria-expanded', 'false');
        }

        closeAll() {
          this.items.forEach((item) => this.close(item));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
